export default __webpack_public_path__ + "static/media/Hero-Picture 5 - without text.2d90fda0.jpg";